import React from "react"
import Bookmark from "../bookmark/bookmark"
import Link from "../../link"
import { calcMatchStrength } from "../assessment/utils/utils"
import { FormattedMessage, useIntl } from "react-intl"
import ThumbsFeedback from "../assessment/thumbs-feedback/ThumbsFeedback.js"
import { demandTranslations } from "../../utils"
import { useCareers } from "../assessment/useCareers.js"
import "./cards-careers.css"

const CardCareers = props => {
  const {
    img,
    title,
    slug,
    salaryEntry,
    salaryExperienced,
    correlation,
    demand,
    category,
    objectID,
    contentType,
    hideBookmarks,
    thumbsFeedback,
    setDislikedCareerSlugs,
    relatedMajors=[],
    relatedPrograms=[],
    subdomainSchoolName,
    subdomainAbbreviation,
    recommendationLabel,
  } = props
  const { locale } = useIntl()
  const allCosmicjsCareers = useCareers(locale)
  const matchedCareer = allCosmicjsCareers.find(career => career.slug === slug)
  const subsetMajors = relatedMajors.slice(0, 5)
  const subsetPrograms = relatedPrograms.slice(0, 5)

  return (
    <div
      className="component-card component-card-careers"
      style={{ alignItems: "flex-start" }}
      data-object={objectID}
    >
      <div
        className="component-card-image component-card-image-careers"
        style={{ position: "relative" }}
      >
        <Link to={`/career/${slug}`} state={{backURL: ''}}>
          {correlation && (
            <span className={`match-label-${calcMatchStrength(correlation)}`}>
              <label>
                {locale === "es-ES" ?
                  calcMatchStrength(correlation) === "Excellent" ? "Excelente" :
                    calcMatchStrength(correlation) === "Good" ? "Bueno" :
                      calcMatchStrength(correlation) === "Fair" ? "Regular" :
                        calcMatchStrength(correlation) :
                  calcMatchStrength(correlation)}
              </label>
            </span>
          )}
          {recommendationLabel && (
            <span 
              className="recommendation-label"
              style={{
                position: 'absolute',
                bottom: '6px',
                left: '0',
                backgroundColor: '#c837d3',
                padding: '0 10px'
              }}
            >
              <label style={{
                color: 'white',
                padding: '3px 5px',
                fontSize: '16px',
                margin: 0
              }}>
                {recommendationLabel === 'stay steady' ? 'Stay Steady' : 'Change Course'}
              </label>
            </span>
          )}
          <img
            src={`${img}?q=&auto=compress,&w=712&h=446&fit=crop&crop=faces`}
            alt={title ? `${title} career` : 'Career image'}
            className="printer-none"
          />
        </Link>
      </div>
      <div className="component-card-meta component-card-meta-careers">
        <div className="component-card-meta-header component-card-meta-header-careers">
          {!hideBookmarks && (
            <>
              <Bookmark
                contentTitle={title}
                classContext={"careers"}
                contentId={objectID}
                contentSlug={slug}
                contentType={contentType}
                jobCategories={matchedCareer?.career_job_categories}
                careerPathwaysFilter={matchedCareer?.career_pathways_filter}
              />
            </>
          )}
          {thumbsFeedback && (
            <ThumbsFeedback
              contentId={objectID}
              contentSlug={slug}
              onDislike={slug => setDislikedCareerSlugs(prev => [...prev, slug])}
            />
          )}

          <Link
            to={`/career/${slug}`}
            className="component-card-title component-card-title-careers"
          >
            {title}
          </Link>
        </div>
        <div className="card-career-body">
          {((salaryEntry && salaryExperienced) || demand || category) && (
            <div className="card-career-stats">
              {salaryEntry && salaryExperienced && (
                <div className="component-card-salary component-card-salary-careers">
                  <strong><FormattedMessage id="cards-careers-salary-range" defaultMessage="Salary Range" />: </strong>${salaryEntry}
                  <span> - </span>${salaryExperienced}
                </div>
              )}
              {demand && (
                <div className="component-card-demand component-card-demand-careers">
                  <strong><FormattedMessage id="cards-careers-demand" defaultMessage="Demand" />: </strong>
                  {demandTranslations[demand][locale] || demand}
                </div>
              )}
              {category && (
                <div className="component-card-category component-card-category-careers">
                  <strong><FormattedMessage id="cards-careers-category" defaultMessage="Category" />: </strong>
                  {category}
                </div>
              )}
            </div>
          )}
          {(subsetMajors.length > 0 || subsetPrograms.length > 0) && (
            <div className="majors-and-programs-container">
              {subsetMajors.length > 0 && (
                <div className="related-majors-container">
                  <strong>
                    <FormattedMessage id="results-related-degrees" defaultMessage="Related Degrees" />:
                  </strong>
                  {subsetMajors.map((major, index) => (
                    <Link key={major.slug} to={`/major/${major.slug}`} className="major-link">
                      {major.title}
                      {((index + 1) < subsetMajors.length) ? "," : ""}
                    </Link>
                  ))}
                </div>
              )}
              {subsetPrograms.length > 0 && (
                <div className="related-programs-container">
                  <strong>
                    {subdomainSchoolName ? (
                      <>
                      <FormattedMessage id="results-programs-at" defaultMessage="Programs at" />
                      {` ${subdomainAbbreviation ?? subdomainSchoolName.trim() // this uses an explicit abbreviation if available in organizationOptions.js, otherwise will calculate an abbreviation from the school name
                                              .split(" ")
                                              .map(word => word.toLowerCase())
                                              .filter(word => word && !["of", "the"].includes(word))
                                              .map(word => word[0].toUpperCase())
                                              .join("")}:`}
                      </>
                    ) : (
                      <FormattedMessage id="results-related-programs" defaultMessage="Related Programs:" />
                    )}
                  </strong>
                  {subsetPrograms.map((program, index) => (
                    <a key={program.cip_code} href={program.program_url} target="_blank" className="program-link">
                      {program.program_title || program.cip_title}
                      {((index + 1) < subsetPrograms.length) ? "," : ""}
                    </a>
                  ))}
                </div>
              )}
            </div>
          )}          
        </div>
        {/* <div className="component-card-meta-careers-toggles-container">
          {thumbsFeedback && <ThumbsFeedback contentId={objectID} setDislikedCareerSlugs={setDislikedCareerSlugs} />}

          {!hideBookmarks && (
            <>
              <Bookmark
                contentTitle={title}
                classContext={"careers"}
                contentId={objectID}
                contentSlug={slug}
                contentType={contentType}
              />
            </>
          )}
        </div> */}
      </div>
    </div>
  )
}

export default CardCareers
